export default __webpack_public_path__ + "static/media/uploader-insuletOmnipod-3.4f5f7cbc.png";